export default {
    ABORTO_ESPONTANEO: 'O03',
    ABORTO_NAO_ESPECIFICADO: 'O06',
    ABORTO_POR_RAZOES_MEDICAS_E_LEGAIS: 'O04',
    ANORMALIDADES_DA_CONTRACAO_UTERINA: 'O62',
    ASSISTENCIA_E_EXAME_POS_NATAL: 'Z39',
    CHOQUE_DURANTE_OU_SUBSEQUENTE_AO_TRABALHO_DE_PARTO_E_O_PARTO: 'O751',
    COMPLICACOES_DO_TRABALHO_DE_PARTO_E_DO_PARTO_NAO_ESPECIFICADAS: 'O759',
    DEMORA_DO_PARTO_APOS_RUPTURA_ARTIFICIAL_DAS_MEMBRANAS: 'O755',
    DEMORA_DO_PARTO_APOS_RUPTURA_ESPONTANEA_OU_NAO_ESPECIFICADA_DAS_MEMBRANAS: 'O756',
    DESCOLAMENTO_PREMATURO_DA_PLACENTA_ABRUPTIO_PLACENTAE: 'O45',
    EXAME_DE_ROTINA_DE_SAUDE_DA_CRIANCA: 'Z001',
    EXTRACAO_MENSTRUAL: 'Z303',
    FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO: 'O61',
    LACERACAO_DO_PERINEO_DURANTE_O_PARTO: 'O70',
    NASCIDOS_VIVOS_SEGUNDO_O_LOCAL_DE_NASCIMENTO: 'Z38',
    NASCIMENTO_GEMELAR_GEMEOS_AMBOS_NATIVIVOS_NADO_VIVOS: 'Z372',
    NASCIMENTO_GEMELAR_GEMEOS_NATIMORTOS_FETO_MORTOS: 'Z374',
    NASCIMENTO_GEMELAR_UM_DOS_GEMEOS_NATIVIVO_NADO_VIVO_O_OUTRO_NATIMORTO_FETO_MORTO: 'Z373',
    NASCIMENTO_NAO_ESPECIFICADO: 'Z379',
    NASCIMENTO_UNICO_NATIMORTO_FETO_MORTO: 'Z371',
    NASCIMENTO_UNICO_NATIVIVO_NADO_VIVO: 'Z370',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADE_PELVICA_DA_MAE: 'O65',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_MA_POSICAO_OU_MA_APRESENTACAO_DO_FETO: 'O64',
    OUTRAS_COMPLICACOES_DE_PROCEDIMENTOS_OU_DE_CIRURGIA_OBSTETRICA: 'O754',
    OUTRAS_COMPLICACOES_ESPECIFICADAS_DO_TRABALHO_DE_PARTO_E_DO_PARTO: 'O758',
    OUTRAS_FORMAS_DE_OBSTRUCAO_DO_TRABALHO_DE_PARTO: 'O66',
    OUTROS_NASCIMENTOS_MULTIPLOS_ALGUNS_NATIVIVOS_NADO_VIVOS: 'Z376',
    OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIMORTOS_FETO_MORTOS: 'Z377',
    OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIVIVOS_NADO_VIVOS: 'Z375',
    OUTROS_PRODUTOS_ANORMAIS_DA_CONCEPCAO: 'O02',
    OUTROS_TIPOS_DE_ABORTO: 'O05',
    OUTROS_TIPOS_DE_PARTO_UNICO_ASSISTIDO: 'O83',
    OUTROS_TRAUMATISMOS_OBSTETRICOS: 'O71',
    PARTO_MULTIPLO: 'O84',
    PARTO_UNICO_ESPONTANEO: 'O80',
    PARTO_UNICO_POR_CESARIANA: 'O82',
    PARTO_UNICO_POR_FORCEPS_OU_VACUO_EXTRATOR: 'O81',
    PARTO_VAGINAL_SUBSEQUENTE_A_CESARIANA_ANTERIOR: 'O757',
    RETENCAO_DA_PLACENTA_E_DAS_MEMBRANAS_SEM_HEMORRAGIAS: 'O73',
    RUPTURA_PREMATURA_DE_MEMBRANAS: 'O42',
    SOFRIMENTO_MATERNO_DURANTE_O_TRABALHO_DE_PARTO_E_O_PARTO: 'O750',
    SUPERVISAO_DE_GRAVIDEZ_COM_GRANDE_MULTIPARIDADE: 'Z354',
    SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ABORTO: 'Z351',
    SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ASSISTENCIA_PRE_NATAL_INSUFICIENTE: 'Z353',
    SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ESTERILIDADE: 'Z350',
    SUPERVISAO_DE_GRAVIDEZ_COM_OUTROS_ANTECEDENTES_DE_PROCRIACAO_PROBLEMATICA: 'Z352',
    SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO: 'Z35',
    SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO_DEVIDO_A_PROBLEMAS_SOCIAIS: 'Z357',
    SUPERVISAO_DE_GRAVIDEZ_NORMAL: 'Z34',
    SUPERVISAO_DE_GRAVIDEZ_NORMAL_NAO_ESPECIFICADA: 'Z349',
    SUPERVISAO_DE_OUTRAS_GRAVIDEZES_DE_ALTO_RISCO: 'Z358',
    SUPERVISAO_DE_OUTRA_GRAVIDEZ_NORMAL: 'Z348',
    SUPERVISAO_DE_PRIMEIRA_GRAVIDEZ_NORMAL: 'Z340',
    SUPERVISAO_DE_PRIMIGESTA_IDOSA: 'Z355',
    SUPERVISAO_DE_PRIMIGESTA_MUITO_JOVEM: 'Z356',
    SUPERVISAO_NAO_ESPECIFICADA_DE_GRAVIDEZ_DE_ALTO_RISCO: 'Z359',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORMALIDADE_DO_CORDAO_UMBILICAL: 'O69',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_HEMORRAGIA_INTRAPARTO_NAO_CLASSIFICADOS_EM_OUTRA_PARTE: 'O67',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_SOFRIMENTO_FETAL: 'O68',
    TRABALHO_DE_PARTO_PRE_TERMO: 'O60',
    TRABALHO_DE_PARTO_PROLONGADO: 'O63',
    OVO_CLARO_E_MOLA_NAO_HIDATIFORME: 'O020',
    ABORTO_RETIDO: 'O021',
    OUTROS_PRODUTOS_ANORMAIS_DA_CONCEPCAO_ESPECIFICADOS: 'O028',
    PRODUTO_ANORMAL_DA_CONCEPCAO_NAO_ESPECIFICADO: 'O029',
    ABORTO_ESPONTANEO_INCOMPLETO_COMPLICADO_POR_INFECCAO_DO_TRATO_GENITAL_OU_DOS_ORGAOS_PELVICOS: 'O030',
    ABORTO_ESPONTANEO_INCOMPLETO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA: 'O031',
    ABORTO_ESPONTANEO_INCOMPLETO_COMPLICADO_POR_EMBOLIA: 'O032',
    ABORTO_ESPONTANEO_INCOMPLETO_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIFICADAS: 'O033',
    ABORTO_ESPONTANEO_INCOMPLETO_SEM_COMPLICACOES: 'O034',
    ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COMPLICADO_P_INFEC_DO_TRATO_GENITAL_OU_ORG_PELVICOS: 'O035',
    ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COMPLICADO_P_HEMOR_EXCESSIVA_OU_TARDIA: 'O036',
    ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COMPLICADO_P_EMBOLIA: 'O037',
    ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIF: 'O038',
    ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_SEM_COMPLICACOES: 'O039',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COMPLICADO_P_INFEC_DO_TRATO_GENITAL_OU_ORG_PELVICOS: 'O040',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA: 'O041',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COMPLICADO_POR_EMBOLIA: 'O042',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COM_OUTRAS_COMPLIC_OU_COM_COMPLIC_NAO_ESPECIFICADAS: 'O043',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_SEM_COMPLICACOES: 'O044',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_N_ESPEC_COMPLIC_P_INFEC_DO_TRATO_GENIT_ORG_PELV: 'O045',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_COMPLIC_P_HEMORRAGIA_EXCESSIVA_OU_TARDIA: 'O046',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_COMPLIC_P_EMBOLIA: 'O047',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_COM_OUT_COMPLIC_COMPLIC_N_ESPECIFICADAS: 'O048',
    ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_SEM_COMPLICACOES: 'O049',
    OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COMPLICADO_POR_INFECCAO_DO_TRATO_GENITAL_OU_DOS_ORGAOS_PELVICOS: 'O050',
    OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA: 'O051',
    OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COMPLICADO_POR_EMBOLIA: 'O052',
    OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIFICADAS: 'O053',
    OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_SEM_COMPLICACOES: 'O054',
    OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLIC_P_INFEC_DO_TRATO_GENIT_ORG_PELV: 'O055',
    OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA: 'O056',
    OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLICADO_POR_EMBOLIA: 'O057',
    OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COM_OUT_COMPLIC_COMPLIC_NAO_ESPECIFICADAS: 'O058',
    OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_SEM_COMPLICACOES: 'O059',
    ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COMPLICADO_POR_INFEC_DO_TRATO_GENITAL_OU_DOS_ORGAOS_PELVICOS: 'O060',
    ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA: 'O061',
    ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COMPLICADO_POR_EMBOLIA: 'O062',
    ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIFICADAS: 'O063',
    ABORTO_NAO_ESPECIFICADO_INCOMPLETO_SEM_COMPLICACOES: 'O064',
    ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLIC_P_INFEC_DO_TRATO_GENIT_ORG_PELV: 'O065',
    ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLIC_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA: 'O066',
    ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLICADO_POR_EMBOLIA: 'O067',
    ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COM_OUT_COMPLIC_COMPLIC_N_ESPECIFICADAS: 'O068',
    ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_SEM_COMPLICACOES: 'O069',
    RUPTURA_PREMATURA_DE_MEMBRANAS_COM_INICIO_DO_TRABALHO_DE_PARTO_DENTRO_DE_24_HORAS: 'O420',
    RUPTURA_PREMATURA_DE_MEMBRANAS_COM_INICIO_DO_TRABALHO_DE_PARTO_DEPOIS_DAS_PRIMEIRAS_24_HORAS: 'O421',
    RUPTURA_PREMATURA_DE_MEMBRANAS_COM_TRABALHO_DE_PARTO_RETARDADO_POR_TERAPEUTICA: 'O422',
    RUPTURA_PREMATURA_DE_MEMBRANAS_NAO_ESPECIFICADA: 'O429',
    DESCOLAMENTO_PREMATURO_DA_PLACENTA_COM_DEFICIENCIA_DE_COAGULACAO: 'O450',
    OUTRO_DESCOLAMENTO_PREMATURO_DA_PLACENTA: 'O458',
    DESCOLAMENTO_PREMATURO_DA_PLACENTA_NAO_ESPECIFICADO: 'O459',
    TRABALHO_DE_PARTO_PRE_TERMO_COM_PARTO_PRE_TERMO: 'O601',
    TRABALHO_DE_PARTO_PRE_TERMO_COM_PARTO_A_TERMO: 'O602',
    FALHA_NA_INDUCAO_MEDICA_DO_TRABALHO_DE_PARTO: 'O610',
    FALHA_NA_INDUCAO_INSTRUMENTAL_DO_TRABALHO_DE_PARTO: 'O611',
    OUTRAS_FORMAS_DE_FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO: 'O618',
    FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO_NAO_ESPECIFICADA: 'O619',
    CONTRACOES_INICIAIS_INADEQUADAS: 'O620',
    INERCIA_UTERINA_SECUNDARIA: 'O621',
    OUTRAS_FORMAS_DE_INERCIA_UTERINA: 'O622',
    TRABALHO_DE_PARTO_PRECIPITADO: 'O623',
    CONTRACOES_UTERINAS_HIPERTONICAS_INCOORDENADAS_OU_PROLONGADAS: 'O624',
    OUTRAS_ANORMALIDADES_DA_CONTRACAO_UTERINA: 'O628',
    ANORMALIDADES_DA_CONTRACAO_UTERINA_NAO_ESPECIFICADAS: 'O629',
    PROLONGAMENTO_DO_PRIMEIRO_PERIODO_DILATACAO: 'O630',
    PROLONGAMENTO_DO_SEGUNDO_PERIODO_EXPULSAO: 'O631',
    PARTO_RETARDADO_DO_SEGUNDO_GEMEO_DO_TERCEIRO_GEMEO_ETC: 'O632',
    TRABALHO_DE_PARTO_PROLONGADO_NAO_ESPECIFICADO: 'O639',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ROTACAO_INCOMPLETA_DO_POLO_CEFALICO_FETAL: 'O640',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_PELVICA: 'O641',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_DE_FACE: 'O642',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_DE_FRONTE: 'O643',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_DE_OMBRO: 'O644',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_COMPLEXA: 'O645',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_OUTRAS_FORMAS_DE_MA_APRESENTACAO_E_MA_POSICAO: 'O648',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_MA_POSICAO_OU_MA_APRESENTACAO_NAO_ESPECIFICADAS: 'O649',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_DEFORMIDADE_PELVICA: 'O650',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_CONTRACAO_GERAL_DA_PELVE: 'O651',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_CONTRACAO_DO_ESTREITO_SUPERIOR: 'O652',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_CONTRACAO_DO_ESTREITO_INFERIOR_OU_DA_CAVIDADE_MEDIANA: 'O653',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_DESPROPORCAO_FETO_PELVICA_NAO_ESPECIFICADA: 'O654',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADE_DOS_ORGAOS_PELVICOS_MATERNOS: 'O655',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_OUTRAS_ANORMALIDADES_PELVICAS_MATERNAS: 'O658',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADES_PELVICAS_MATERNAS_NAO_ESPECIFICADAS: 'O659',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDO_A_DISTOCIA_DE_OMBRO: 'O660',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_POR_COLISAO_DE_GEMEOS: 'O661',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_POR_FETO_EXCEPCIONALMENTE_GRANDE: 'O662',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDO_A_OUTRAS_ANORMALIDADES_DO_FETO: 'O663',
    FALHA_DE_TENTATIVA_DE_TRABALHO_DE_PARTO_NAO_ESPECIFICADA: 'O664',
    FALHA_DE_APLICACAO_DE_FORCEPS_E_VACUO_EXTRATOR_NAO_ESPECIFICADA: 'O665',
    OUTRAS_FORMAS_DE_OBSTRUCAO_DO_TRABALHO_DE_PARTO_ESPECIFICADAS: 'O668',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_NAO_ESPECIFICADO: 'O669',
    HEMORRAGIA_INTRAPARTO_COM_DEFICIENCIA_DE_COAGULACAO: 'O670',
    OUTRAS_HEMORRAGIAS_INTRAPARTO: 'O678',
    HEMORRAGIA_INTRAPARTO_NAO_ESPECIFICADA: 'O679',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORMALIDADE_DA_FREQUENCIA_CARDIACA_FETAL: 'O680',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_MECONIO_NO_LIQUIDO_AMNIOTICO: 'O681',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORM_NA_FREQ_CARDIACA_FETAL_C_MECONIO_NO_LIQ_AMNIOTICO: 'O682',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_EVIDENCIAS_BIOQUIMICAS_DE_SOFRIMENTO_FETAL: 'O683',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_OUTRAS_EVIDENCIAS_DE_SOFRIMENTO_FETAL: 'O688',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_SOFRIMENTO_FETAL_NAO_ESPECIFICADO: 'O689',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_PROLAPSO_DO_CORDAO: 'O690',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_CIRCULAR_DE_CORDAO_COM_COMPRESSAO: 'O691',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_OUTROS_ENOVELAMENTOS_DO_CORDAO: 'O692',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_CORDAO_CURTO: 'O693',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_VASA_PRAEVIA: 'O694',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_LESAO_VASCULAR_DO_CORDAO: 'O695',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_OUTRAS_COMPLICACOES_DO_CORDAO: 'O698',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_COMPLICACOES_DO_CORDAO_NAO_ESPECIFICADAS: 'O699',
    LACERACAO_DE_PERINEO_DE_PRIMEIRO_GRAU_DURANTE_O_PARTO: 'O700',
    LACERACAO_DE_PERINEO_DE_SEGUNDO_GRAU_DURANTE_O_PARTO: 'O701',
    LACERACAO_DE_PERINEO_DE_TERCEIRO_GRAU_DURANTE_O_PARTO: 'O702',
    LACERACAO_DE_PERINEO_DE_QUARTO_GRAU_DURANTE_O_PARTO: 'O703',
    LACERACAO_DE_PERINEO_DURANTE_O_PARTO_NAO_ESPECIFICADA: 'O709',
    RUPTURA_DO_UTERO_ANTES_DO_INICIO_DO_TRABALHO_DE_PARTO: 'O710',
    RUPTURA_DO_UTERO_DURANTE_O_TRABALHO_DE_PARTO: 'O711',
    INVERSAO_DO_UTERO_POS_PARTO: 'O712',
    LACERACAO_OBSTETRICA_DO_COLO_DO_UTERO: 'O713',
    LACERACAO_VAGINAL_ALTA_ISOLADA_DE_ORIGEM_OBSTETRICA: 'O714',
    OUTRAS_LESOES_OBSTETRICAS_AOS_ORGAOS_PELVICOS: 'O715',
    LESAO_OBSTETRICA_DAS_ARTICULACOES_E_DOS_LIGAMENTOS_PELVICOS: 'O716',
    HEMATOMA_OBSTETRICO_DA_PELVE: 'O717',
    OUTROS_TRAUMATISMOS_OBSTETRICOS_ESPECIFICADOS: 'O718',
    TRAUMATISMO_OBSTETRICO_NAO_ESPECIFICADO: 'O719',
    RETENCAO_DA_PLACENTA_SEM_HEMORRAGIA: 'O730',
    RETENCAO_DE_PARTES_DA_PLACENTA_OU_DAS_MEMBRANAS_SEM_HEMORRAGIA: 'O731',
    PARTO_ESPONTANEO_CEFALICO: 'O800',
    PARTO_ESPONTANEO_PELVICO: 'O801',
    OUTROS_TIPOS_DE_PARTO_UNICO_ESPONTANEO: 'O808',
    PARTO_UNICO_ESPONTANEO_NAO_ESPECIFICADO: 'O809',
    PARTO_POR_FORCEPS_BAIXO: 'O810',
    PARTO_POR_FORCEPS_DA_CAVIDADE_MEDIANA: 'O811',
    FORCEPS_DA_CAVIDADE_MEDIANA_COM_ROTACAO: 'O812',
    OUTROS_TIPOS_DE_PARTO_POR_FORCEPS_E_OS_NAO_ESPECIFICADOS: 'O813',
    PARTO_POR_VACUO_EXTRATOR: 'O814',
    PARTO_POR_COMBINACAO_DE_FORCEPS_E_VACUO_EXTRATOR: 'O815',
    PARTO_POR_CESARIANA_ELETIVA: 'O820',
    PARTO_POR_CESARIANA_DE_EMERGENCIA: 'O821',
    PARTO_POR_CESARIANA_PARA_HISTERECTOMIA: 'O822',
    OUTROS_TIPOS_DE_PARTO_UNICO_POR_CESARIANA: 'O828',
    PARTO_POR_CESARIANA_NAO_ESPECIFICADA: 'O829',
    EXTRACAO_PELVICA: 'O830',
    OUTROS_TIPOS_DE_PARTO_PELVICO_ASSISTIDO: 'O831',
    OUTRAS_FORMAS_DE_PARTO_COM_O_AUXILIO_DE_MANIPULACAO: 'O832',
    PARTO_DE_GRAVIDEZ_INTRA_ABDOMINAL_COM_FETO_VIAVEL: 'O833',
    CIRURGIA_DESTRUTIVA_PARA_FACILITAR_O_PARTO: 'O834',
    OUTROS_TIPOS_ESPECIFICADOS_DE_PARTO_UNICO_ASSISTIDO: 'O838',
    PARTO_UNICO_ASSISTIDO_NAO_ESPECIFICADO: 'O839',
    PARTO_MULTIPLO_TODOS_ESPONTANEOS: 'O840',
    PARTO_MULTIPLO_TODOS_POR_FORCEPS_OU_VACUO_EXTRATOR: 'O841',
    PARTO_MULTIPLO_TODOS_POR_CESARIANA: 'O842',
    OUTRO_TIPO_DE_PARTO_MULTIPLO: 'O848',
    PARTO_MULTIPLO_NAO_ESPECIFICADO: 'O849',
    RESULTADO_DO_PARTO: 'Z37',
    ASSISTENCIA_E_EXAME_IMEDIATAMENTE_APOS_O_PARTO: 'Z390',
    ASSISTENCIA_E_EXAME_DA_MAE_NUTRIZ: 'Z391',
    SEGUIMENTO_POS_PARTO_DE_ROTINA: 'Z392',
}
